'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var stringHasSubstring = require('./string-has-substring-fe5ca9ab.js');
require('./enums-de2d9d36.js');
var menuItem = require('./menu-item-7ef567aa.js');
require('./styled-4a7495b5.js');
var arrayHasValue = require('./array-has-value-a0a72c46.js');

var MultiSelectOptions = function (_a) {
    var options = _a.options, value = _a.value, hideCheckboxes = _a.hideCheckboxes, onChange = _a.onChange, readOnly = _a.readOnly, searchText = _a.searchText, fallbackContent = _a.fallbackContent, isAllValuesSelected = _a.isAllValuesSelected;
    var handleOptionClick = React.useCallback(function (newData, isChecked) {
        if (onChange) {
            onChange(arrayHasValue.addOrRemoveFromDataBasedOnChecked(options.filter(function (option) { return value.includes(option.value); }), newData, isChecked), newData === null || newData === void 0 ? void 0 : newData.value, isChecked);
        }
    }, [onChange, value]);
    var optionsForRender = React.useMemo(function () { return options.filter(function (_a) {
        var label = _a.label;
        return stringHasSubstring.stringHasSubstring(label, searchText);
    }); }, [options, searchText, hideCheckboxes, value, handleOptionClick]);
    var noResults = isAllValuesSelected || (!optionsForRender.length && searchText);
    return (React__default.createElement(React__default.Fragment, null, noResults ? fallbackContent : optionsForRender.map(function (option) { return (React__default.createElement(menuItem.MenuItem, { key: option.label + "-Menu-Item", showCheckBox: !hideCheckboxes, storedValue: option, isSelected: arrayHasValue.arrayHasValue(options.filter(function (_a) {
            var optionValue = _a.value;
            return value.includes(optionValue);
        }), option), label: option.label, icon: option.icon, onChange: handleOptionClick, readOnly: readOnly || option.readOnly })); })));
};

exports.MultiSelectOptions = MultiSelectOptions;
